<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 17 17"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        :fill="color"
        fill-rule="nonzero"
        d="M8 .667c4.05 0 7.333 3.283 7.333 7.333 0 4.05-3.283 7.333-7.333 7.333C3.95 15.333.667 12.05.667 8 .667 3.95 3.95.667 8 .667zm0 1C4.502 1.667 1.667 4.502 1.667 8S4.502 14.333 8 14.333 14.333 11.498 14.333 8 11.498 1.667 8 1.667zm-.033 8.409c.192 0 .353.065.484.195.13.131.195.292.195.484 0 .212-.068.38-.205.5-.136.122-.294.183-.474.183-.185 0-.347-.06-.485-.18s-.207-.288-.207-.503c0-.192.067-.353.2-.484.134-.13.298-.195.492-.195zm.11-5.538c.44 0 .83.082 1.166.244.338.163.598.384.782.663.184.28.276.584.276.912 0 .258-.053.484-.157.679-.105.194-.23.362-.374.503-.144.142-.403.38-.777.714-.103.094-.186.177-.249.248-.062.071-.108.137-.139.196-.03.06-.053.118-.07.178-.017.059-.042.163-.075.312-.058.316-.239.474-.543.474-.158 0-.29-.052-.398-.155-.108-.103-.162-.257-.162-.46 0-.256.04-.477.118-.664.08-.186.184-.35.315-.492.13-.141.307-.309.528-.503.195-.17.335-.299.422-.385.086-.087.16-.183.219-.29.059-.106.089-.222.089-.346 0-.243-.09-.448-.272-.615-.18-.167-.414-.251-.7-.251-.333 0-.58.084-.737.253-.158.169-.292.417-.402.745-.103.343-.299.515-.587.515-.17 0-.314-.06-.431-.18-.117-.12-.176-.25-.176-.39 0-.288.093-.58.278-.877.186-.296.456-.541.812-.736.355-.194.77-.292 1.244-.292z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-faq",
  components: {},
})
export class IconFaq extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconFaq;
</script>
